import { React, useState, useEffect, useRef, useContext } from "react";
import {
  RightLayoutContainer,
  DetailFields,
  GroupTitle,
  PageTitleComp,
} from "../../styledElements";
import { Tooltip, Button, Row, Col, Form, Input, PageHeader } from "antd";
import Iconmoon from "../../../Components/IconsFiles/icon";
import { HaberForm } from "../../styledElements";
import "antd-country-phone-input/dist/index.css";
import "flagpack/dist/flagpack.css";
import { Switch } from "antd";
import warning from "../../../Assets/Icons/warning.png";
import { ModalPopup } from "../../../Components/Modal/modal";
import { GlobalSet, Styled } from "../../pageStyled";
import trusted from "../../../Assets/Icons/trusted.png";
import alertYellow from "../../../Assets/Icons/alertYellow.svg";
import alertRed from "../../../Assets/Icons/alertRed.svg";
import alertGreen from "../../../Assets/Icons/alertGreen.svg";
import AlertContainer from "../../../Components/AlertBoxes/alertBox";
import {
  saveWorkflowSettings,
  getWorkflowSettings,
} from "../../../Services/workFlowSettingsServices";

const WorkFlowSettings = (props) => {
  const [switchTooltip, setSwitchTooltip] = useState(false);
  const [switchApprovalFlow, setSwitchApprovalFlow] = useState(false);
  const [switchMergeGradeQuality, setSwitchMergeGradeQuality] = useState(false);
  const [switchGSM, setSwitchGSM] = useState(false);
  const [switchBF, setSwitchBF] = useState(false);
  const [switchMoisture, setSwitchMoisture] = useState(false);
  const [switchReelDia, setSwitchReelDia] = useState(false);
  const [actionResponse, setActionResponse] = useState({});
  const [orderManagementSettings, setOrderManagementSettings] = useState("");
  const [deckleManagementSettings, setDeckleManagementSettings] = useState("");
  const [toaster, setToaster] = useState(false);
  const userDetails = JSON.parse(localStorage.getItem("user-details"));
  const [switchStock, setSwitchStock] = useState(false);
  const [switchDeckleApprovalFlow, setSwitchDeckleApprovalFlow] =
  useState(false);
  const [switchFetchOrdersfromERP,setSwitchFetchOrdersfromERP] = useState(false);
  useEffect(() => {
    (async () => {
      let orderMangtSettings = await getWorkflowSettings("order_management");
      setOrderManagementSettings(orderMangtSettings?.data);
      setSwitchTooltip(orderMangtSettings?.data?.edit_after_approval?.value);
      setSwitchFetchOrdersfromERP(
        orderMangtSettings?.data?.fetch_orders_from_erp?.value
      )
      setSwitchApprovalFlow(orderMangtSettings?.data?.approval_flow?.value);
      let deckleMangtSettings = await getWorkflowSettings("deckle_management");
      setDeckleManagementSettings(deckleMangtSettings?.data);
      setSwitchMergeGradeQuality(
        deckleMangtSettings?.data?.merging?.grade_qualities?.value
      );
      setSwitchDeckleApprovalFlow(
        deckleMangtSettings?.data?.approval_flow?.value
      )
      setSwitchGSM(deckleMangtSettings?.data?.merging?.gsm?.value);
      setSwitchBF(deckleMangtSettings?.data?.merging?.burst_factor?.value);
      setSwitchMoisture(deckleMangtSettings?.data?.merging?.moisture?.value);
      setSwitchReelDia(
        deckleMangtSettings?.data?.merging?.reel_diameter?.value
      );
      setSwitchStock(deckleMangtSettings?.data?.dynamic_stocks?.value);
    })();
  }, []);

  const showToaster = () => {
    setToaster(true);
    setTimeout(() => setToaster(false), 3000);
  };

  const saveData = async (reqBody) => {
    const resp = await saveWorkflowSettings(reqBody);
    return resp;
  };

  const editOrderHandler = async (checked) => {
    let reqBody = {
      edit_after_approval: {
        value: checked,
      },
    };
    try {
      let resp = await saveData(reqBody);
      if (!resp?.error) {
        setSwitchTooltip(checked);
      } else {
        setActionResponse(resp);
        showToaster();
      }
    } catch (err) {
      setActionResponse(err.response.data);
      showToaster();
    }
  };
  const editERPOrdersHandler = async (checked) => {
    let reqBody = {
      fetch_orders_from_erp: {
        value: checked,
      },
    };
    try {
      let resp = await saveData(reqBody);
      if (!resp?.error) {
       setSwitchFetchOrdersfromERP(checked);
       editOrderHandler(false);
      } else {
        setActionResponse(resp);
        showToaster();
      }
    } catch (err) {
      setActionResponse(err.response.data);
      showToaster();
    }
  };
  const editApprovalFlowHandler = async (checked) => {
    let reqBody = {
      approval_flow: {
        value: checked,
      },
    };
    try {
      let resp = await saveData(reqBody);
      if (!resp?.error) {
        setSwitchApprovalFlow(checked);
       editOrderHandler(false);
      }
      else {
        setActionResponse(resp);
        showToaster();
      }
      
    } catch (err) {
      setActionResponse(err.response.data);
      showToaster();
    }
  };

  const mergeGradeandQualityHandler = async (checked) => {
    let reqBody = {
      merging: {
        grade_qualities: {
          value: checked,
        },
      },
    };
    try {
      let resp = await saveData(reqBody);
      if (!resp?.error) {
        setSwitchMergeGradeQuality(checked);
      } else {
        setActionResponse(resp);
        showToaster();
      }
    } catch (err) {
      setActionResponse(err.response.data);
      showToaster();
    }
  };

  const mergeGSMHandler = async (checked) => {
    let reqBody = {
      merging: {
        gsm: {
          value: checked,
        },
      },
    };
    try {
      let resp = await saveData(reqBody);
      if (!resp?.error) {
        setSwitchGSM(checked);
      } else {
        setActionResponse(resp);
        showToaster();
      }
    } catch (err) {
      setActionResponse(err.response.data);
      showToaster();
    }
  };

  const mergeMoistureHandler = async (checked) => {
    let reqBody = {
      merging: {
        moisture: {
          value: checked,
        },
      },
    };
    try {
      let resp = await saveData(reqBody);
      if (!resp?.error) {
        setSwitchMoisture(checked);
      } else {
        setActionResponse(resp);
        showToaster();
      }
    } catch (err) {
      setActionResponse(err.response.data);
      showToaster();
    }
  };

  const stockSwitchHandler = async (checked) => {
    setSwitchStock(checked);
    let reqBody = {
      dynamic_stocks: {
        value: checked,
      },
    };
    try {
      let resp = await saveData(reqBody);
      if (!resp?.error) {
        setSwitchStock(checked);
      } else {
        setActionResponse(resp);
        showToaster();
        setSwitchStock(!checked);
      }
    } catch (err) {
      setActionResponse(err.response.data);
      showToaster();
      setSwitchStock(!checked);
    }
  };
  const editDeckleApprovalOrderHandler = async (checked) => {
    let reqBody = {
      deckle_approval_flow: {
        value: checked,
      },
    };
    try {
       let resp = await saveData(reqBody);
      if (!resp?.error) {
        setSwitchDeckleApprovalFlow(checked);
      } else {
        setActionResponse(resp);
        showToaster();
      }
    } catch (err) {
      setActionResponse(err.response.data);
      showToaster();
    }
  };
  const mergeBFHandler = async (checked) => {
    let reqBody = {
      merging: {
        burst_factor: {
          value: checked,
        },
      },
    };
    try {
      let resp = await saveData(reqBody);
      if (!resp?.error) {
        setSwitchBF(checked);
      } else {
        setActionResponse(resp);
        showToaster();
      }
    } catch (err) {
      setActionResponse(err.response.data);
      showToaster();
    }
  };

  const mergeReelDiaHandler = async (checked) => {
    let reqBody = {
      merging: {
        reel_diameter: {
          value: checked,
        },
      },
    };
    try {
      let resp = await saveData(reqBody);
      if (!resp?.error) {
        setSwitchReelDia(checked);
      } else {
        setActionResponse(resp);
        showToaster();
      }
    } catch (err) {
      setActionResponse(err.response.data);
      showToaster();
    }
  };

  return orderManagementSettings && deckleManagementSettings ? (
    <RightLayoutContainer className="globalset">
      <PageTitleComp>
        <PageHeader ghost={false} title="Workflow Settings"></PageHeader>
      </PageTitleComp>
      <DetailFields>
        <HaberForm>
          <div className="groupDetailWrap">
            <Form name="basic" autoComplete="off" className="haberLogin">
              <Row gutter={[16, 16]} className="groupForm">
                <Col span={8}>
                  <GroupTitle>
                    <h2>Order Management</h2>
                    <p>The workflow for order can be customized here</p>
                  </GroupTitle>
                </Col>
                <Col span={16}>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Fetch Orders from ERP</label>
                        <p>
                          If enabled, orders will be fetched from the ERP
                          system. Users cannot create, edit, or cancel orders
                          from Kaiznn.
                        </p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <GlobalSet>
                          <Styled>
                            <Tooltip
                              placement="bottomRight"
                              title={
                                !switchFetchOrdersfromERP
                                  ? "Enabling this will fetch orders from ERP and disable manual order management."
                                  : "Disabling this will allow users to create and edit orders directly in Kaiznn."
                              }
                              getPopupContainer={(triggerNode) => triggerNode}
                            >
                              <Switch
                                checked={switchFetchOrdersfromERP}
                                onChange={editERPOrdersHandler}
                                className="switch-new"
                                disabled={
                                  // false
                                  true
                                }
                              />
                            </Tooltip>
                          </Styled>
                        </GlobalSet>
                      </div>
                    </Col>
                  </Row>
                  { (
                    <Row className="centerAlign">
                      <Col span={12}>
                        <div className="boxFieldTitle">
                          <label>Approval Flow </label>
                          <p>
                            If enabled, orders must be approved
                            before they are eligible for deckle matching or
                            production.
                          </p>
                        </div>
                      </Col>
                      <Col span={12}>
                        <div className="boxFormType">
                          <GlobalSet>
                            <Styled>
                              <Tooltip
                                placement="bottomRight"
                                title={
                                  !switchApprovalFlow
                                    ? "Enabling this will require order approval before planning or production."
                                    : "Disabling this will allow orders to skip approval before planning."
                                }
                                getPopupContainer={(triggerNode) => triggerNode}
                              >
                                <Switch
                                  checked={switchApprovalFlow}
                                  onChange={editApprovalFlowHandler}
                                  className="switch-new"
                                  disabled={
                                  //  false
                                  true
                                  }
                                />
                              </Tooltip>
                            </Styled>
                          </GlobalSet>
                        </div>
                      </Col>
                    </Row>
                  )}
                  {(switchFetchOrdersfromERP === false &&
                    switchApprovalFlow === true) && (
                    <Row className="centerAlign">
                      <Col span={12}>
                        <div className="boxFieldTitle">
                          <label>Edit Order after Approval</label>
                          <p>
                            If enabled, users can edit an order even after
                            approval. Edited orders will require re-approval.
                          </p>
                        </div>
                      </Col>
                      <Col span={12}>
                        <div className="boxFormType">
                          <GlobalSet>
                            <Styled>
                              <Tooltip
                                placement="bottomRight"
                                title={
                                  !switchTooltip
                                    ? "Enabling this will allow editing approved orders (changes will need re-approval)."
                                    : " Disabling this will prevent editing approved orders."
                                }
                                getPopupContainer={(triggerNode) => triggerNode}
                              >
                                <Switch
                                  checked={switchTooltip}
                                  onChange={editOrderHandler}
                                  className="switch-new"
                                  // disabled={
                                  //   true
                                  // }
                                />
                              </Tooltip>
                            </Styled>
                          </GlobalSet>
                        </div>
                      </Col>
                    </Row>
                  )}
                </Col>
              </Row>
              <Row gutter={[16, 16]} className="groupForm">
                <Col span={8}>
                  <GroupTitle>
                    <h2>Deckle Management</h2>
                    <p>
                      The workflow for deckle matching can be customized here
                    </p>
                  </GroupTitle>
                </Col>
                <Col span={16}>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Approval Flow</label>
                        <p>
                          If enabled, job cards must be approved
                          before they are eligible for deckle matching or
                          production
                        </p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <GlobalSet>
                          <Styled>
                            <Tooltip
                              placement="bottomRight"
                              title={
                                switchDeckleApprovalFlow
                                  ? "Disabling this will allow users to create and edit orders directly in Kaiznn."
                                  : "Enabling this will allow orders to skip approval before planning."
                              }
                              getPopupContainer={(triggerNode) => triggerNode}
                            >
                              <Switch
                                checked={switchDeckleApprovalFlow}
                                onChange={editDeckleApprovalOrderHandler}
                                className="switch-new"
                                disabled={
                                  !userDetails.roles.workflow_settings.edit
                                }
                              />
                            </Tooltip>
                          </Styled>
                        </GlobalSet>
                      </div>
                    </Col>
                  </Row>{" "}
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Dynamic Stocks</label>
                        <p>
                          If enabled, deckle matching will consider real-time
                          stock availability during planning.
                        </p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <GlobalSet>
                          <Styled>
                            <Tooltip
                              placement="bottomRight"
                              title={
                                !switchStock
                                  ? "Enabling this will use real-time stock data in deckle matching."
                                  : "Disabling this will use saved stock data, not live updates"
                              }
                              getPopupContainer={(triggerNode) => triggerNode}
                            >
                              <Switch
                                checked={switchStock}
                                onChange={stockSwitchHandler}
                                className="switch-new"
                                disabled={
                                  !userDetails.roles.workflow_settings.edit
                                }
                              />
                            </Tooltip>
                          </Styled>
                        </GlobalSet>
                      </div>
                    </Col>
                  </Row>{" "}
                </Col>
              </Row>
              <Row gutter={[16, 16]} className="groupForm">
                <Col span={8}>
                  <GroupTitle>
                    <h2>Merging Criteria Section</h2>
                    <p>
                      This section allows configuration of how orders are merged
                      during deckle matching.
                    </p>
                  </GroupTitle>
                </Col>
                <Col span={16}>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Merge Grade and Qualities</label>
                        <p>
                          If enabled, users can merge grades and qualities
                          during deckle planning.
                        </p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <GlobalSet>
                          <Styled>
                            <Tooltip
                              placement="bottomRight"
                              title={
                                !switchMergeGradeQuality
                                  ? "Enable grades & qualities merging in deckle planning"
                                  : "Disable grades & qualities merging in deckle planning"
                              }
                              getPopupContainer={(triggerNode) => triggerNode}
                            >
                              <Switch
                                checked={switchMergeGradeQuality}
                                onChange={mergeGradeandQualityHandler}
                                className="switch-new"
                                disabled={
                                  !userDetails.roles.workflow_settings.edit
                                }
                              />
                            </Tooltip>
                          </Styled>
                        </GlobalSet>
                      </div>
                    </Col>
                  </Row>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Merge GSM</label>
                        <p>
                          If enabled, users can merge different GSM during
                          deckle planning.
                        </p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <GlobalSet>
                          <Styled>
                            <Tooltip
                              placement="bottomRight"
                              title={
                                !switchGSM
                                  ? "Enable GSM merging in deckle planning"
                                  : "Disable GSM merging in deckle planning"
                              }
                              getPopupContainer={(triggerNode) => triggerNode}
                            >
                              <Switch
                                checked={switchGSM}
                                onChange={mergeGSMHandler}
                                className="switch-new"
                                disabled={
                                  !userDetails.roles.workflow_settings.edit
                                }
                              />
                            </Tooltip>
                          </Styled>
                        </GlobalSet>
                      </div>
                    </Col>
                  </Row>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Merge BF</label>
                        <p>
                          If enabled, users can merge different BF during deckle
                          planning.
                        </p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <GlobalSet>
                          <Styled>
                            <Tooltip
                              placement="bottomRight"
                              title={
                                !switchBF
                                  ? "Enable BF merging in deckle planning"
                                  : "Disable BF merging in deckle planning"
                              }
                              getPopupContainer={(triggerNode) => triggerNode}
                            >
                              <Switch
                                checked={switchBF}
                                onChange={mergeBFHandler}
                                className="switch-new"
                                disabled={
                                  !userDetails.roles.workflow_settings.edit
                                }
                              />
                            </Tooltip>
                          </Styled>
                        </GlobalSet>
                      </div>
                    </Col>
                  </Row>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Merge Moisture</label>
                        <p>
                          If enabled, users can merge different Moisture during
                          deckle planning.
                        </p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <GlobalSet>
                          <Styled>
                            <Tooltip
                              placement="bottomRight"
                              title={
                                !switchMoisture
                                  ? "Enable Moisture merging in deckle planning"
                                  : "Disable Moisture merging in deckle planning"
                              }
                              getPopupContainer={(triggerNode) => triggerNode}
                            >
                              <Switch
                                checked={switchMoisture}
                                onChange={mergeMoistureHandler}
                                className="switch-new"
                                disabled={
                                  !userDetails.roles.workflow_settings.edit
                                }
                              />
                            </Tooltip>
                          </Styled>
                        </GlobalSet>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Form>
          </div>
        </HaberForm>
      </DetailFields>
      {toaster && (
        <AlertContainer
          closeIcon={true}
          setClose={setToaster}
          color={`${actionResponse.error ? "red" : "green"} toaster`}
          icon={actionResponse.error ? alertRed : alertGreen}
          msg={actionResponse.error ? actionResponse.msg : ""}
        />
      )}
    </RightLayoutContainer>
  ) : (
    <></>
  );
};
export default WorkFlowSettings;
